import { Alert } from "react-bootstrap"

export default function AlertComponent(props) {
  const alertStyle = {
    position: 'fixed',
    right: 0,
    top: '6em',
    zIndex: 1
  }
  return (
      <Alert onClose={() => props.setShow(false)}
             dismissible
             show={props.show}
             style={alertStyle}
             variant='danger'>
        <Alert.Heading><strong className="me-auto">{props.header}</strong></Alert.Heading>
        {props.body}
      </Alert>
  )
}